export const toDate = (value) => {
  try {
    if (!value) return null;
    if (value.toDate) return value.toDate();
    const dateValue = new Date(value);
    return Number.isNaN(dateValue.getTime()) ? null : dateValue;
  } catch {
    return null;
  }
};

export const getScheduleDueStats = (
  schedules,
  startOfToday,
  endOfToday,
  oneMonthFromNow
) => {
  let dueToday = 0;
  let dueNextMonth = 0;

  schedules.forEach((schedule) => {
    const rows = Array.isArray(schedule.DueDatesTable)
      ? schedule.DueDatesTable
      : Array.isArray(schedule.dueDatesTable)
      ? schedule.dueDatesTable
      : [];

    rows.forEach((row) => {
      const status = String(row.Status || row.status || "").trim().toLowerCase();
      if (["completed", "cancelled", "canceled"].includes(status)) return;

      const dueDate = toDate(row.DueDate ?? row.dueDate);
      if (!dueDate) return;

      if (dueDate >= startOfToday && dueDate <= endOfToday) {
        dueToday += 1;
      } else if (dueDate > endOfToday && dueDate <= oneMonthFromNow) {
        dueNextMonth += 1;
      }
    });
  });

  return { dueToday, dueNextMonth };
};
